import "core-js/modules/es.array.push.js";
import api from "./../../common/api";
import common from "./../../common/common.js";
import { ElMessage } from 'element-plus';
import * as qiniu from 'qiniu-js';
import qs from 'qs';
export default {
  name: 'component_upload',
  props: {
    isShow: {
      default: false,
      type: Boolean
    },
    isButton: {
      default: false,
      type: Boolean
    },
    showFileList: {
      default: false,
      type: Boolean
    },
    showImgList: {
      default: false,
      type: Boolean
    },
    filesData: {
      type: Array,
      value: []
    },
    // 父组件传入的历史文件
    uploadTitle: {
      default: '上 传',
      type: String
    },
    isProgress: {
      default: false,
      type: Boolean
    },
    multiple: {
      default: false,
      type: Boolean
    },
    limit: {
      default: 1,
      type: Number
    },
    autoReplace: {
      default: true,
      type: Boolean
    },
    maxSize: {
      default: 5,
      type: Number
    },
    uploadSaveLocal: {
      default: true,
      type: Boolean
    },
    imageUrl: {
      type: String,
      default: ''
    },
    file_model: {
      type: String,
      default: 'file_logs'
    },
    file_type: {
      type: String,
      default: 'file'
    },
    file_flag: {
      type: String,
      default: '0'
    },
    storageType: {
      type: String,
      default: 'qiniu'
    },
    icon: {
      type: String,
      default: 'upload'
    },
    buttonThemeType: {
      type: String,
      default: 'primary'
    },
    plain: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      loadProgress: 0,
      buttonText: "暂停上传",
      uploadBtnId: '',
      // 动态按钮ID
      doMain: 'http://case.zsmy.fyakm.com',
      imgUrl: '',
      filePath: '',
      fileList: [],
      // 内部维护的文件列表
      token: '',
      config: {
        headers: {
          'Content-Type': 'multipart/form-data;'
        },
        timeout: 30000
      }
    };
  },
  watch: {
    filesData: {
      // 首次加载的时候执行函数
      immediate: true,
      handler(val) {
        this.fileList = this.initFilesData(val);
      }
    }
  },
  created: function () {
    // 初始化七牛token
    if (localStorage.getItem('isLogin')) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) this.getToken();
    }
    // 初始化进度条标识
    this.progressFlag = this.isProgress ? true : false;
    // 【关键修改1】初始化历史文件，统一uid生成规则
    this.fileList = this.initFilesData(this.filesData);
    //console.log('this.fileList', this.fileList);
    // 初始化动态按钮ID
    this.uploadBtnId = `upload-btn-${Math.random().toString(36).slice(2)}-${Date.now()}`;
  },
  methods: {
    // 【新增方法】初始化历史文件，统一生成uid
    initFilesData(files) {
      if (!Array.isArray(files) || files.length === 0) return [];
      return files.map(file => {
        // 优先使用已有uid，无则基于文件唯一标识生成（url/name/路径）
        if (file.uid) return file;

        // 生成规则：文件url/name + 时间戳（确保唯一）
        const uniqueKey = file.url || file.filename || file.path || Date.now();
        return {
          ...file,
          uid: `file-${uniqueKey.replace(/\//g, '_').replace(/\./g, '-')}` // 替换特殊字符避免冲突
        };
      });
    },

    // 【增强删除逻辑】支持uid/name/url多维度匹配
    removeFile: function (file) {
      // 多维度匹配规则：优先uid → 其次name → 最后url
      this.fileList = this.fileList.filter(item => {
        // 匹配uid
        if (file.uid && item.uid === file.uid) return false;
        // 匹配文件名（兼容历史文件）
        if (file.name && item.name === file.name) return false;
        // 匹配文件url（兜底）
        if (file.url && item.url === file.url) return false;
        return true;
      });

      // 通知父组件更新
      this.$emit('getUploadFile', this.fileList);
      //ElMessage.success('文件已删除');
    },

    // 【新增方法】手动点击删除按钮的处理（统一调用removeFile）
    handleManualRemove(file) {
      // 阻止事件冒泡（避免触发上传组件的默认行为）
      // 直接调用删除方法，传入完整的file对象
      this.removeFile(file);
    },
    // 上传前校验
    handleBeforeUpload: function (file) {
      // 图片大小限制
      if (this.file_type === 'images') {
        const maxSize = this.maxSize * 1024 * 1024;
        if (file.size > maxSize) {
          ElMessage.error('图片大小不能超过' + this.maxSize + 'MB');
          return false;
        }
      }

      // limit=1时自动清空旧文件
      if (this.limit === 1 && this.autoReplace) {
        this.fileList = [];
      }
      this.progressFlag = true;
      return true;
    },
    // 超出文件限制处理
    uploadExceed: function (files, fileList) {
      if (this.limit === 1 && this.autoReplace) {
        // 移除旧文件
        const oldFile = fileList[0];
        if (oldFile) this.removeFile(oldFile);

        // 上传新文件
        const newFile = files[0];
        if (newFile && this.handleBeforeUpload(newFile)) {
          this.requestFile({
            file: newFile
          });
        }
      } else {
        ElMessage.error(`最大上传${this.limit}个文件！继续上传请删除已上传文件`);
      }
    },
    uploadChange: function () {},
    // 七牛SDK上传
    uploadWithSDK: function (token, putExtra, config, domain, file) {
      var that = this;
      if (!file) return;
      var type = file.name.split('.');
      var filePath = common.getTime() + '' + common.randStr(6) + '.' + type[type.length - 1];
      this.filePath = filePath;
      var error = function (err) {
        console.log(err);
      };
      var complete = function (res) {
        console.log(res);
      };
      var next = function (response) {
        that.loadProgress = Math.floor(response.total.percent);
        if (that.loadProgress == 100) {
          // 【关键修改2】上传成功时，使用file.uid（Element Plus生成的）
          that.getFilePath(filePath, '', '', file.uid, file.name);
        }
      };
      var subObject = {
        next,
        error,
        complete
      };
      var observable = qiniu.upload(file, this.filePath, token, putExtra, config);
      var subscription = observable.subscribe(subObject);

      // 上传暂停/继续监听
      that.$nextTick(function () {
        const btn = document.getElementById(that.uploadBtnId);
        if (btn) {
          btn.addEventListener("click", function () {
            if (that.buttonText == "暂停上传") {
              that.buttonText = "继续上传";
              subscription.unsubscribe();
            } else if (that.buttonText == "继续上传") {
              that.buttonText = "暂停上传";
              subscription = observable.subscribe(subObject);
            }
          });
        }
      });
    },
    // 本地上传
    upload_local: function (uploadfile) {
      var that = this;
      var data = new FormData();
      data.append('file', uploadfile.file);
      data.append('file_type', this.file_type);
      data.append('flag', this.file_flag);
      data.append('file_model', this.file_model);
      data.append('storageType', this.storageType);
      this.$post(api.upload(), data, that.config).then(function (res) {
        if (res.rt == 1) {
          // 【关键修改3】本地上传成功，使用文件的原始uid
          that.getFilePath(res.filename, res.path, res.url, uploadfile.file.uid, uploadfile.file.name);
        } else {
          if (res.msg) ElMessage.error(res.msg);
          if (res.page) setTimeout(function () {
            common.clearLogin();
            that.$router.push(res.page);
          }, 300);
        }
      }).catch(function (error) {
        common.networkError(error);
      });
    },
    // 七牛上传
    upload_qiniu: function (param) {
      var file = param.file;
      var domain = this.doMain;
      var config = {
        useCdnDomain: true,
        disableStatisticsReport: false,
        retryCount: 6
      };
      var putExtra = {
        customVars: {}
      };
      this.uploadWithSDK(this.token, putExtra, config, domain, file);
    },
    // 统一上传请求入口
    requestFile: function (param) {
      if (this.uploadSaveLocal) {
        this.upload_local(param);
      } else {
        this.upload_qiniu(param);
      }
    },
    // 文件上传成功后更新列表
    getFilePath: function (filePath, path = '', url = '', uid = '', filename_original = '') {
      this.loadProgress = 100; // 重置进度条
      url = this.uploadSaveLocal ? url : `${this.doMain}/${filePath}`;
      var fileList = [...this.fileList];
      fileList.push({
        url,
        filename: filePath,
        path,
        filename_original: filename_original || '',
        uid: uid || `file-${Date.now()}-${Math.random().toString(36).slice(2)}` // 兜底生成uid
      });

      // 限制文件数量
      if (this.limit <= fileList.length) {
        fileList = fileList.slice(-this.limit);
      }
      this.fileList = fileList;
      this.$emit('getUploadFile', this.fileList);
    },
    // 获取七牛token
    getToken: function () {
      var that = this;
      this.$post(api.doMain() + '/upload/qiniuToken', qs.stringify({})).then(function (res) {
        if (res.rt == 1) that.token = res.token;else ElMessage.warning(res.msg);
      }).catch(function (error) {
        common.networkError(error);
      });
    }
  }
};